import { render, staticRenderFns } from "./teacher_detail.vue?vue&type=template&id=0457dd2e&scoped=true"
import script from "./teacher_detail.vue?vue&type=script&lang=js"
export * from "./teacher_detail.vue?vue&type=script&lang=js"
import style0 from "./teacher_detail.vue?vue&type=style&index=0&id=0457dd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457dd2e",
  null
  
)

export default component.exports